import {
  curry,
  reduce,
  assoc,
  keys,
  always,
  pipe,
  toPairs,
  filter,
  apply,
  fromPairs,
  equals,
  compose,
  unapply,
  flip,
  identity,
  path,
  pick,
  anyPass,
  complement,
  addIndex,
  map,
  prop,
  toString,
  toLower,
  replace,
  isNil,
  view,
  isEmpty,
  invoker
} from 'ramda';

export const stubUndefined = always(void 0); // eslint-disable-line no-void

export const isUndefined = equals(stubUndefined());

export const isNotUndefined = complement(isUndefined);

export const isProduction = equals('production');

export const isNotProduction = complement(isProduction);

const PRDENV = 'prd';
const UATENV = 'uat';
export const isPRDOrUATEnv = env => env === PRDENV || env === UATENV;

export const toArray = unapply(identity);
export const mapIndexed = addIndex(map);
export const flipPath = flip(path);
export const flipView = flip(view);
export const flipPick = flip(pick);
export const flipProp = flip(prop);
export const emptyString = always('');
export const isNotNil = complement(isNil);
export const isNilOrEmpty = anyPass([isNil, isEmpty]);
export const isNotNillNorEmpty = complement(isNilOrEmpty);
export const formatMessage = flip(invoker(1, 'formatMessage'));
export const slugify = compose(
  replace(/-+$/, ''),
  replace(/^-+/, ''),
  replace(/--+/g, '-'),
  replace(/[^\w-]+/g, ''),
  replace(/\s+/g, '-'),
  toLower,
  toString
);

export const filterWithKeys = (pred, obj) => pipe(toPairs, filter(apply(pred)), fromPairs)(obj);

export const renameKeys = curry((keysMap, obj) => reduce((acc, key) => assoc(keysMap[key] || key, obj[key], acc), {}, keys(obj)));

export const noop = always(undefined);

export const insertAt = (array, index, ...elementsArray) => {
  array.splice(index, 0, ...elementsArray);
};

export default {
  stubUndefined,
  isUndefined,
  isNotUndefined,
  isProduction,
  isNotProduction,
  isPRDOrUATEnv,
  toArray,
  mapIndexed,
  flipPath,
  flipView,
  flipPick,
  flipProp,
  emptyString,
  isNotNil,
  isNilOrEmpty,
  isNotNillNorEmpty,
  formatMessage,
  slugify,
  filterWithKeys,
  renameKeys,
  noop,
  insertAt,
};
